import './ArchiveRewardAdPromo.css';

import Modal from 'react-modal';
import { MODAL_CONTENT_DEFAULTS, MODAL_OVERLAY_DEFAULTS, runningAsNativeApp } from './utils.ts';
import { CloseButton } from './CloseButton.tsx';

import { AppStoreButtonLink, PlayStoreButtonLink } from './AppStoreButton.tsx';
import { track } from './umami.ts';

export function ArchiveRewardAdPromo({
    onTryItNow,
    onClose,
    shouldBeOpen,
}: {
    onTryItNow: () => void;
    onClose: () => void;
    shouldBeOpen: boolean;
}) {
    function closeModal() {
        onClose();
    }

    return (
        <Modal
            style={{
                content: {
                    ...MODAL_CONTENT_DEFAULTS,
                    height: 'fit-content',
                    maxWidth: '315px',
                    width: '315px',
                    margin: 'auto auto',
                    boxSizing: 'border-box',
                    padding: '25px',
                },
                overlay: MODAL_OVERLAY_DEFAULTS,
            }}
            onRequestClose={closeModal}
            isOpen={shouldBeOpen}>
            <CloseButton onClose={closeModal} />
            <h2 className='center-text'>New in Triplit 🎉</h2>

            {runningAsNativeApp() && (
                <>
                    <ul className='update-list' style={{ paddingLeft: '0.5rem' }}>
                        <li>
                            Daily puzzles now <b>ramp up</b> in difficulty from Monday to Sunday — a fun new weekly
                            challenge!
                        </li>
                        <li>
                            You can now unlock any archived puzzle by watching a reward ad —{' '}
                            <b>no subscription needed</b>.
                        </li>
                        <li>Once you unlock a puzzle, it&apos;s yours forever 🔓</li>
                        <p className='try-it-now-button-container'>
                            <button
                                className='game-button play-button cursor-pointer try-it-now-button'
                                onClick={() => {
                                    closeModal();
                                    onTryItNow();
                                }}>
                                Unlock a puzzle now!
                            </button>
                        </p>
                    </ul>
                </>
            )}
            {!runningAsNativeApp() && (
                <>
                    <ul className='update-list' style={{ paddingLeft: '0.5rem' }}>
                        <li>
                            Daily puzzles now ramp up in difficulty from Monday to Sunday — a fun new weekly challenge!
                        </li>
                        <li>
                            Unlock archived Triplit puzzles for free <b>on the Triplit app</b>—just watch a reward
                            video.
                        </li>
                    </ul>
                    <h3 className='center-text'>
                        <b>Try it now!</b>
                    </h3>
                    <div
                        className='store-buttons-container'
                        onClick={() => track('app_store_link_clicked_update_promo')}>
                        <PlayStoreButtonLink /> <AppStoreButtonLink />
                    </div>
                </>
            )}
        </Modal>
    );
}
